import CloseFormIcon from 'assets/images/form/closeFormIcon.svg?react';
import { FC, ReactElement, useEffect } from 'react';
import { TFunction } from 'react-i18next';
import FormTitle from 'shared/components/form/formTitle';
import ProgressBar from 'shared/components/progressBar';
import { SectionNavigation } from 'shared/constants/common';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';
import { handleAddOverflow, isMobile } from 'shared/util/utility';

import './styles.scss';

type TextualContent = {
	heading: string;
	subHeading: string;
};

interface Props {
	currentStep: number;
	numberOfSteps: number;
	isDesktop?: boolean;
	closeDialog?: () => void;
	textualContent: TextualContent;
	t: TFunction<'translation'>;
	children: ReactElement;
}

const FormContainer: FC<Props> = ({ currentStep, numberOfSteps, isDesktop, closeDialog, children, textualContent, t }) => {
	const { heading, subHeading } = textualContent;
	const { isViewActive } = useSectionNavigation();

	useEffect(() => {
		if (isMobile() && (isViewActive(SectionNavigation.REGISTRATION) || isViewActive(SectionNavigation.ACCOUNT_VERIFICATION))) {
			handleAddOverflow();
		}
	}, [isViewActive]);

	return (
		<div className="FormContainer">
			<div>
				<div className="FormContainer__headerWrap">
					<ProgressBar currentStep={currentStep} numberOfSteps={numberOfSteps} progressBarType="secondary" />
					{isDesktop && <CloseFormIcon onClick={closeDialog} className="FormContainer__headerWrap--closeIcon" />}
				</div>

				<div className="FormContainer__title">
					<FormTitle title={t(heading)} subTitle={t(subHeading)} />
				</div>
			</div>
			{children}
		</div>
	);
};

export default FormContainer;
